import { forwardRef, useImperativeHandle, useRef, useState } from 'react'
import SignatureCanvas from 'react-signature-canvas'
import {
  SIGNATURE_PLACEHOLDER_HEIGHT,
  SignatureCard,
  SignatureClearButton,
  SignatureHandler,
  SignaturePlaceholder,
  SignatureProps,
  SignatureToolbar,
} from './Pad'
import { useSignatureDimensions } from './SignatureDimensionsContext'

export const DrawSignature = forwardRef<SignatureHandler, SignatureProps>(
  ({ className, ...props }, ref) => {
    const canvasRef = useRef<SignatureCanvas>(null)
    const [isEmpty, setIsEmpty] = useState(true)


    useImperativeHandle(ref, () => {
      return {
        getImage: () => {
          if (canvasRef.current) {
            return canvasRef.current.getTrimmedCanvas().toDataURL()
          }

          return ''
        },
      }
    })

    const signature = useSignatureDimensions()
    
    return (
      <SignatureCard
        style={{
          width: signature.width,
          height: signature.height,
        }}
        isInvalid={props.error}
        className={className}
      >
        <SignatureToolbar>
          <SignatureClearButton
            onClick={() => {
              if (canvasRef.current) {
                setIsEmpty(true)
                canvasRef.current.clear()
              }
            }}
          />
        </SignatureToolbar>
        <div className='absolute'>
          <SignatureCanvas
            onEnd={() => {
              if (props.onChange) {
                props.onChange()
              }
            }}
            backgroundColor='transparent'
            onBegin={() => setIsEmpty(false)}
            ref={canvasRef}
            penColor='black'
            clearOnResize={true}
            canvasProps={{
              width: signature.width,
              height: signature.height,
            }}
          />
        </div>
        <SignaturePlaceholder>
          <div
            style={{
              height: `${signature.height}px`,
            }}
          />
        </SignaturePlaceholder>
      </SignatureCard>
    )
  }
)
